import { MIN_LATITUDE, MAX_LATITUDE, MIN_LONGITUDE, MAX_LONGITUDE } from '@/constants'

/**
 * 緯度経度を小数点以下8桁目で四捨五入し、7桁まで残す
 * @param value 数値
 * @return 小数点以下7桁までの数値(e.g. 38.1234567)
 */
export function roundLatLon7(value: number): number {
  return Number(value.toFixed(7))
}

/**
 * 数値を小数点以下2桁目で四捨五入し、1桁まで残す（表示用）
 * @param value 数値
 * @return 小数点以下1桁までの文字列 (e.g. "1.2", "2.0")
 */
export function round1Decimal(value?: number | null): string {
  if (value === undefined || value === null || isNaN(value)) return '-'
  return value.toFixed(1)
}

/**
 * 任意の値を数値に変換し、有効な数値ならその値を返す。そうでなければnullを返す。
 * @param v 任意の値
 * @return 有限な数値またはnull
 */
export function toNumberOrNull(v: unknown): number | null {
  return Number.isFinite(Number(v)) ? Number(v) : null
}

/**
 * 緯度として有効な値ならその値を返す。そうでなければnullを返す。
 * @param v 任意の値
 * @return 有効な緯度またはnull
 */
export function toValidLat(v: unknown): number | null {
  const validLat = toNumberOrNull(v)
  return validLat !== null && validLat >= MIN_LATITUDE && validLat <= MAX_LATITUDE ? validLat : null
}

/**
 * 経度として有効な値ならその値を返す。そうでなければnullを返す。
 * @param v 任意の値
 * @return 有効な経度またはnull
 */
export function toValidLon(v: unknown): number | null {
  const validLon = toNumberOrNull(v)
  return validLon !== null && validLon >= MIN_LONGITUDE && validLon <= MAX_LONGITUDE
    ? validLon
    : null
}

/**
 * API用日時フォーマット
 * YYYYMMDDHHmm 形式に変換
 */
export function formatApiDate(d: Date): string {
  const yyyy = d.getFullYear()
  const mm = String(d.getMonth() + 1).padStart(2, '0')
  const dd = String(d.getDate()).padStart(2, '0')
  const hh = String(d.getHours()).padStart(2, '0')
  const min = String(d.getMinutes()).padStart(2, '0')

  return `${yyyy}${mm}${dd}${hh}${min}`
}
